module.exports = __webpack_public_path__ + "img/orange_042.bbfbbe91.png";